import apiClient from './client'

export const communityApi = {
  getPosts: async (params = {}) => {
    const response = await apiClient.get('/community/posts', { params })
    return response.data
  },

  createPost: async (data) => {
    // FormData handling is done in the request interceptor
    const response = await apiClient.post('/community/posts', data)
    return response.data
  },

  getPost: async (id) => {
    const response = await apiClient.get(`/community/posts/${id}`)
    return response.data
  },

  reactToPost: async (id, data) => {
    const response = await apiClient.post(`/community/posts/${id}/react`, data)
    return response.data
  },

  commentOnPost: async (id, data) => {
    const response = await apiClient.post(`/community/posts/${id}/comments`, data)
    return response.data
  },

  reactToComment: async (postId, commentId, data) => {
    const response = await apiClient.post(`/community/posts/${postId}/comments/${commentId}/react`, data)
    return response.data
  },
}

